import { u } from "./assets/index-CUpSEhYe.js";
import { a, g, u as u2 } from "./assets/index-CgZzOVq6.js";
import { u as useToastStore } from "./assets/index-yvMoeLcl.js";
import "vue";
import "./tokens.js";
import "vue-i18n";
import "vue-demi";
import "./locales.js";
import "pinia";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import "./assets/XAlert-C6ysGEVR.js";
import "./assets/index-BNd8MWnO.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "./XLink.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
function useToast() {
  const store = useToastStore();
  return {
    success: (msg, options) => store.addToast(msg, {
      ...options,
      type: "success"
    }),
    error: (msg, options) => store.addToast(msg, {
      ...options,
      type: "error"
    }),
    info: (msg, options) => store.addToast(msg, {
      ...options,
      type: "info"
    }),
    warning: (msg, options) => store.addToast(msg, {
      ...options,
      type: "warning"
    })
  };
}
export {
  a as activeLocale,
  g as getLocaleInstance,
  u as useBreakpoints,
  u2 as useI18n,
  useToast
};
